import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Login = lazy(() => import('./pages/Login'));
const Servers = lazy(() => import('./pages/Servers'));
const ServerSelection = lazy(() => import('./pages/ServerSelection'));
const Users = lazy(() => import('./pages/Users'));
const UserDetail = lazy(() => import('./pages/UserDetail'));
const ApiKeys = lazy(() => import('./pages/ApiKeys'));
const Profile = lazy(() => import('./pages/Profile'));
const SystemAdmins = lazy(() => import('./pages/SystemAdmins'));

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <div className="flex h-screen items-center justify-center bg-slate-950 text-white">Loading...</div>;
    return user ? children : <Navigate to="/login" />;
};

const PageLoader = () => (
    <div className="flex h-full w-full items-center justify-center p-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
    </div>
);

function App() {
    return (
        <Router>
            <AuthProvider>
                <div className="bg-slate-950 min-h-screen text-slate-200">
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            <Route path="/login" element={<Login />} />

                            <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/servers" element={<Servers />} />
                                <Route path="/users" element={<ServerSelection />} />
                                <Route path="/users/:serverId" element={<Users />} />
                                <Route path="/users/:serverId/:userId" element={<UserDetail />} />
                                <Route path="/admins" element={<SystemAdmins />} />
                                <Route path="/apikeys" element={<ApiKeys />} />
                                <Route path="/profile" element={<Profile />} />
                            </Route>
                        </Routes>
                    </Suspense>
                </div>
            </AuthProvider>
        </Router>
    );
}

export default App;
